import txfOnboardingUrl from '@/assets/misc/txf_onboarding.gif'
import {
  CardButton,
  CardItemContent,
  CardItemContentDecoration,
  CardSubtitle,
  CardTitle,
} from '@/components/Card'

interface TxfJobOnboardingCardProps {
  onAction?: () => unknown
}

export function TxfJobOnboardingCard({ onAction }: TxfJobOnboardingCardProps) {
  return (
    <CardButton onPress={onAction}>
      <CardItemContent
        align="center"
        isInteractive
        decoration={
          <CardItemContentDecoration thumbnail>
            <img
              src={txfOnboardingUrl}
              width="128"
              height="128"
              alt="TXF Onboarding"
            />
          </CardItemContentDecoration>
        }
      >
        <CardTitle>Organize your tax information</CardTitle>
        <CardSubtitle>
          Check the info we extracted from your uploaded documents and complete
          any remaining fields.
        </CardSubtitle>
      </CardItemContent>
    </CardButton>
  )
}
